import { call, put } from "redux-saga/effects";
import qs from "qs";

import api from "../../services/api";
import SimuladorPrevidenciaActions from "../ducks/simuladorPrevidencia";
import SimulacaoPrevidencia from '../../support';
import translate from "../../i18n";

interface RequestData {
  salarioParticipacao?: number;
  body?: {};
}

interface RequestDataContribuicaoBasica {
  contribuicaoMaxima?: number;
  fatorContribuicao?: number
  body?: {};
}

interface RequestDataSimulacao {
  idadeInicial?: string;
  idadeFinal?: string;
  valorRemuneracao?: string;
  valorAporteInicial?: string;
  valorMigracao?: string;
  tipoSimulacao?: string;
  percentualContribuicao?: string;
  percentualSaldoBeneficio?: string;
  percentualPagamentoUnico?: string;
  body?: {};
  simulacao: {}
}

export function* consultarSimulacaoRequest(action: RequestDataSimulacao) {
  try {
    const { simulacao } = action;

    const { data } = yield call(api.post, SimulacaoPrevidencia().bUSA + '/previdencia/simulacaoprevidencia/cdpuro/v1', qs.stringify(simulacao));
    if (data) {
     
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaSuccess()
      );

      yield put(
        SimuladorPrevidenciaActions.atualizarSimulacao(data.registros)
      );


    } else {
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
        error: message,
      })
    );
  }
}

export function* consultarContribuicaoBasica(action: RequestDataContribuicaoBasica) {
  try {
    const { data } = yield call(api.post, SimulacaoPrevidencia().bUSA + '/previdencia/contribuicaobasica/cdpuro/v1', qs.stringify(action.body));
    if (data) {
     
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaSuccess()
      );

      yield put(
        SimuladorPrevidenciaActions.atualizarContribuicaoBasica(data)
      );


    } else {
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
        error: message,
      })
    );
  }
}

export function* consultarContribuicaoMaximaRequest(action: RequestData) {
  try {
    const { salarioParticipacao } = action;

    const params = {
      patrocinador: "01",
      percentualContribuicao: 100,
      salarioParticipacao: salarioParticipacao,
      mesAtual: new Date().getMonth() + 1,
      anoAtual: new Date().getFullYear()
    };
    const { data } = yield call(api.get, SimulacaoPrevidencia().bUSA + '/previdencia/contribuicaomaxima/cdpuro/v1', {params: params,});
    if (data) {
     
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaSuccess()
      );

      yield put(
        SimuladorPrevidenciaActions.atualizarContribuicaoMaxima(data)
      );

  
    } else {
      yield put(
        SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
          error: translate.t("app.mensagem.erro"),
        })
      );
    }
  } catch (error) {
    let message = translate.t("app.mensagem.erro");

    if (error.response && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }

    yield put(
      SimuladorPrevidenciaActions.simuladorPrevidenciaFailure({
        error: message,
      })
    );
  }
}
